import { css } from 'emotion';

export default {
    groupLabel: css`
        padding-top: 8px;
    `,
    dropdown: css`
        margin-bottom: 10px;
    `
};
